import { render, staticRenderFns } from "./OrganizationContactUploadDocument.vue?vue&type=template&id=31d2d04e&"
import script from "./OrganizationContactUploadDocument.vue?vue&type=script&lang=js&"
export * from "./OrganizationContactUploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports